import React, { useMemo } from 'react';
import List from '@mui/material/List';

import routesConfig from '../../../../../pages/routesConfig';
import NavVerticalGroup from './VerticalNavGroup';
import VerticalCollapse from './VerticalCollapse';
import VerticalItem from './VerticalItem';
import { checkAllowedAccess } from '@tenant/core/AppPermission/checkAllowedAccess.helper';
import { useSelector } from 'react-redux';
import WhatsNewNavItem from '../../../../../components/WhatsNew/WhatsNewNavItem';

const VerticalNav = () => {
  const { permissions } = useSelector((state) => state.authorization);
  const newRoutesConfig = useMemo(
    () =>
      routesConfig
        .map((route) => ({
          ...route,
          children: route.children.filter((e) =>
            checkAllowedAccess(permissions, e.permissionIds),
          ),
        }))
        .filter((route) => route.children.length > 0),
    [routesConfig, permissions],
  );
  return (
    <List
      sx={{
        position: 'relative',
        padding: 0,
      }}
      component='div'
    >
      {newRoutesConfig.map((item) => (
        <React.Fragment key={item.id}>
          {item.type === 'group' && <NavVerticalGroup item={item} level={0} />}

          {item.type === 'collapse' && (
            <VerticalCollapse item={item} level={0} />
          )}

          {item.type === 'item' && <VerticalItem item={item} level={0} />}

          {item.type === 'whatsNew' && (
            <WhatsNewNavItem level={0} />
          )}
        </React.Fragment>
      ))}
    </List>
  );
};

export default VerticalNav;
